import PropertyFeatured from "./PropertyFeatured";

export default PropertyFeatured;
